import { render, staticRenderFns } from "./ApprovedBy.vue?vue&type=template&id=2d9b860a&scoped=true"
import script from "./ApprovedBy.vue?vue&type=script&lang=js"
export * from "./ApprovedBy.vue?vue&type=script&lang=js"
import style0 from "./ApprovedBy.vue?vue&type=style&index=0&id=2d9b860a&prod&lang=scss"
import style1 from "./ApprovedBy.vue?vue&type=style&index=1&id=2d9b860a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9b860a",
  null
  
)

export default component.exports